var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"simple-page"},[_c('HeadNav',{attrs:{"selectedLanguage":"en","page":"cookie"}}),_vm._v(" "),_c('main',{staticClass:"doc-page"},[_c('h1',[_vm._v("Cookie Policy")]),_vm._v(" "),_c('DocBlocks',{attrs:{"blocks":_vm.blocks}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }